export const getLocations = async () => {
  return process.env.LANG === "cn"
    ? await import("../locations/locations.cn.json", {
        assert: { type: "json" },
      })
    : await import("../locations/locations.en.json", {
        assert: { type: "json" },
      });
};
